export const replaceLinebreak = text => text.split("\n").join("<br />");
export const replaceTabs = text =>
  text.split("\t").join("&nbsp;&nbsp;&nbsp;&nbsp;");

// For textarea
export const replaceLinebreakTextarea = text => text.split("\n").join("&#10;");
export const replaceTabsTextarea = text =>
  text.split("\t").join("&nbsp;&nbsp;&nbsp;&nbsp;");
